import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyOwnerStatementContent',
  standalone: true
})
export class PropertyOwnerStatementContentPipe implements PipeTransform {

  transform(value?: string): string {
    switch (value) {
      case 'Właściciel': {
        return 'jestem właścicielem';
      }
      case 'Współwłaściciel': {
        return 'jestem współwłaścicielem';
      }
      case 'Najemca': {
        return 'jestem najemcą';
      }
      case 'Dzierżawca nieruchomości': {
        return 'jestem dzierżawcą nieruchomości';
      }
      case 'Korzystam z nieruchomości w ramach służebności': {
        return 'korzystam z nieruchomości w ramach służebności';
      }
      default:
        return '';
    }
  }

}
